import { defaultEnvs } from "../../Constants";

export default function getEnvValue(name) {
  return process.env[name] || defaultEnvs[name];
}
